import { render, staticRenderFns } from "./PaymentLineFooterItem.vue?vue&type=template&id=fbdcb32e"
import script from "./PaymentLineFooterItem.vue?vue&type=script&lang=js"
export * from "./PaymentLineFooterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports